exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer_1clKC {\n    padding: 0 80px;\n}\n\n.infoContainer_1clKC > div {\n    padding: 10px;\n}\n\n.infoContainer_1clKC span {\n    font-size: 18px;\n    line-height: 25px;\n    letter-spacing: 1px;\n    text-align: center;\n    padding-bottom: 10px;\n}\n\n.gapSection6_1T9X- {\n    height: 590px;\n}\n\n.initialBoxImage_2ezN6 img {\n    max-width: 100px;\n    max-height: 34px;\n    height: auto;\n    width: auto;\n}\n\n.blockInput_2DTOK {\n    display: block !important;\n}\n\n\n.signatureSize_3FiWy  img {\n    max-width: 200px;\n    max-height: 80px;\n}\n", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer_1clKC",
	"gapSection6": "gapSection6_1T9X-",
	"initialBoxImage": "initialBoxImage_2ezN6",
	"blockInput": "blockInput_2DTOK",
	"signatureSize": "signatureSize_3FiWy"
};